export default __webpack_public_path__ + "static/media/PERFIL_ADMINISTRADOR.eb2a2235.png";